import React from "react";
import { closeModal, openModal } from "../../store/slices/editModalSlice";
import { useDispatch, useSelector } from "react-redux";
import InfoModal from "../Modals/InfoModal";
import { openModalDelete } from "../../store/slices/deleteModalCategorySlice";
import DeleteModalCategory from "../Modals/DeleteModal/DeleteModalCategory";
import EditModalCategory from "../Modals/EditModal/EditModalCategory";

const TableItemsCategoryResponsive = ({ dataCategories }) => {
  const dispatch = useDispatch();
  const editModalState = useSelector((state) => state.editModalCategory);

  const handleEditCategory = (categoryName) => {};
  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleOpenModal = (id) => {
    dispatch(openModal(id));
  };
  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  function getYesNoTextFromBoolean(value) {
    return value ? "Po" : "Jo";
  }

  return (
    <>
      <div className="block sm:hidden space-y-4">
        {dataCategories.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Emri:</strong> {item.name}
            </p>
            <p>
              <strong>Emri 1:</strong> {item.subtitle1}
            </p>
            <p>
              <strong>Emri 2:</strong> {item.subtitle2}
            </p>
            <p>
              <strong>Premium:</strong>{" "}
              {getYesNoTextFromBoolean(item.isPremium)}
            </p>

            <div className="flex flex-wrap items-center gap-2 pt-2">
              <button className="text-blue-500">
                <InfoModal
                  title="Info rreth kategorise"
                  onCancel={handleCloseModal}
                  inputLabel1="Lloji i kategorisë"
                  inputLabel2="Emri 1"
                  inputLabel4="Emri 2"
                />
              </button>

              <button
                onClick={() => handleEditItem(item.id)}
                className="text-green-600"
              >
                <EditModalCategory
                  id={item.id}
                  title="Edito një kategori"
                  submitButtonText="Edito kategorinë"
                  categoryName="Emri i kategorisë"
                  subtitleName="Emri 1"
                  subtitleName2="Emri 2"
                  premiumStatus="A eshte premium"
                  isOpen={editModalState[item.id] === true}
                />
              </button>

              <button
                onClick={() => handleDeleteItem(item.id)}
                className="text-red-500"
              >
                <DeleteModalCategory id={item.id} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TableItemsCategoryResponsive;
